import {call, delay as delayEffect} from 'typed-redux-saga'

type RetryOptions = {
  delay: number
  retries: number | Function
}

const RETRY_DEFAULTS: RetryOptions = {
  delay: 100,
  retries: 2,
}

export function retry(options?: RetryOptions): MethodDecorator {
  const {delay, retries} = {...RETRY_DEFAULTS, ...(options ?? {})}
  let counter
  return function (target: Object, _: string | symbol, descriptor: PropertyDescriptor) {
    const original = descriptor.value
    descriptor.value = function* (...args: any) {
      let shouldRetry: boolean
      if (typeof retries === 'number') {
        counter = retries
      }
      do {
        try {
          return yield call(original.bind(target), ...args)
        } catch (error) {
          shouldRetry = !!(typeof retries === 'function' ? retries(error) : counter--)

          if (!shouldRetry) {
            throw error
          }

          if (delay) {
            yield* delayEffect(delay)
          }
        }
      } while (shouldRetry)
    }
  }
}
